export default class IntegrationType {
  id?: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.name = obj.name || null;
  }

  public static of(obj: any): IntegrationType {
    return new IntegrationType(obj || {});
  }

  public static ofList(obj: any[]): IntegrationType[] {
    return obj.map(this.of);
  }
}
